<template>
    <div class="total-box">
        <span class="name-box">
          <span class="voucher-name">{{getConcurrency.product_name}}</span>
          <span class="product-name" v-if="productType !== 'one' && productType !== 'package'">{{getConcurrency.description}}</span>
        </span>
        <span class="price-box">
          <span class="total-price">{{setNumberCommas(getConcurrency.amount)}}원</span>
          <a href="#" v-if="productType !== 'use_one'" class="product-link" @click.prevent="purchase">구매하기</a>
        </span>
    </div>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'voucher-total-box',
  props: {
    currentVoucherInfo: { type: Object },
    productType: { type: String },
    purchase: { type: Function }
  },
  computed: {
    getConcurrency () {
      return get(this.currentVoucherInfo, ['concurrency', '0'])
    }
  },
  methods: {
    setNumberCommas (data) {
      if (!data) return 0
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>
